export default __webpack_public_path__ + "static/media/step2_2.e3696eb3.PNG";